const TIUN_EVENT = 'TIUN_EVENT'
const TIUN_UPDATE_CONTENT = 'TIUN_UPDATE_CONTENT'
const TIUN_SNIPPET_INITIALIZED = 'TIUN_SNIPPET_INITIALIZED'
const TIUN_HIDE_PAYWALL = 'TIUN_HIDE_PAYWALL'
const TIUN_SHOW_PAYWALL = 'TIUN_SHOW_PAYWALL'
const TIUN_SNIPPET_INTERACTION = 'TIUN_SNIPPET_INTERACTION'

const constants = {
  TIUN_EVENT,
  TIUN_UPDATE_CONTENT,
  TIUN_SNIPPET_INITIALIZED,
  TIUN_HIDE_PAYWALL,
  TIUN_SHOW_PAYWALL,
  TIUN_SNIPPET_INTERACTION,
} as const

export default constants
